import React from 'react';
import PropTypes from 'prop-types';

import { Button } from '@app/ui';

function CrashedPage({ onReload, canReload }) {
    return (
        <div
            className="gds-flex gds-flex--content-center gds-flex--justify-center gds-flex--direction-col gds-flex--align-center -pos-rel -p-v-4"
            style={{ width: '100%', height: '100%' }}
        >
            <div className="gds-flex__item gds-flex__item--grow-0 gds-text--header-xl -text-center -m-b-3 -color-tx-gold">
                <i className="fas fa-exclamation-triangle -m-h-1" />
            </div>
            <div className="gds-flex__item gds-flex__item--grow-0 gds-text--header-md -text-center">
                Page Loading Error
            </div>
            <div className="gds-flex__item gds-flex__item--grow-0 gds-text--body-lg -text-center">
                Please try again
            </div>
            {canReload && (
                <div className="gds-flex__item gds-flex__item--grow-0 -text-center -m-t-3">
                    <Button size="small" variant="primary" onClick={onReload}>
                        Reload
                    </Button>
                </div>
            )}
        </div>
    );
}

CrashedPage.propTypes = {
    onReload: PropTypes.func.isRequired,
    canReload: PropTypes.bool.isRequired,
};

export default CrashedPage;
